

















import {Component, Inject, Prop, Vue} from 'vue-property-decorator';

type Value = number | [number, number] | null;
import {Attachment} from '@/model/api';
import {Estimate} from '@/model/Estimate';

@Component({})
export default class AttachmentControl extends Vue {
    @Inject()
    public readonly model: Estimate;

    @Prop({type: Object, required: true})
    public readonly attachment: Attachment;

    private processing: boolean = false;

    public remove(): void {
        if (this.model.removeAttachment === undefined) {
            throw new Error('Estimate does not support attachment removal');
        }

        if (window.confirm(this.$tc('form.attachments.removeConfirmation'))) {
            this.processing = true;

            this.model.removeAttachment(this.attachment.id)
                .then(() => this.$emit('removed'));
        }
    }
}
